const ROOTSTOCK_COLLECTIVE_ROUTE = {
  MYCOLLECTIVE: {
    NAME: 'MyCollective',
    PATH: 'mycollective'
  },
  PROPOSALS: {
    NAME: 'Proposals',
    PATH: 'proposals'
  }
};

export { ROOTSTOCK_COLLECTIVE_ROUTE };
